import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import { HomeMainView } from '@/components/HomeTradeFocus';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
export default function HomePage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Head><title>{"Sizzle | Food, Beverage & Consumer Goods Growth Platform"}</title><meta name="description" content="Get products known, tried and purchased. Grow sales, channels and markets with the connected trade ecosystem." /><meta property="og:title" content="Sizzle | Food, Beverage & Consumer Goods Growth Platform" /><meta property="og:description" content="Get products known, tried and purchased. Grow sales, channels and markets with brands, retailers, buyers, distributors and partners." /></Head><div><HomeMainView /></div></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}